// extracted by mini-css-extract-plugin
module.exports = {"container":"_2VUgxYwcbD-LZ67rgFhQnu","expandButton":"_2C74khAKjYSun3MbjXjYNr","expandIcon":"_2uviRBVRz2mQ1zYQpL3yb-","rotated":"_3gJ-WJjCDDZt76h9shb1Rh"};